import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import { Box, Button, Stack } from '@mui/material';

import {
  Text,
  api,
  getAndValidateFirstFileFromFileList,
  useLoggedInAuthContext,
  useToast,
} from 'common';

import { DropZone } from '../../../../../../../../components/DragAndDrop';
import { useUploadFileContext } from '../../../../../../../KnowledgeBase/fileUploadContext';
import { useReactFlowViewContext } from '../../../../context/context';

interface DefaultKnowledgeBaseFileDropzoneProps {
  onBrowseFiles: () => void;
}

/**
 * Default dropzone component shown when no knowledge base files or file references are selected.
 * Once a file is selected, this is replaced by the AdditionalKnowledgeBaseFileUploadDropzone component.
 */
export function DefaultKnowledgeBaseFileDropzone(props: DefaultKnowledgeBaseFileDropzoneProps) {
  const { onBrowseFiles } = props;
  const { showError } = useToast();
  const { setFile } = useUploadFileContext();
  const { hasPermission } = useLoggedInAuthContext();
  const { isEditable } = useReactFlowViewContext();

  if (!hasPermission.UpdateKnowledgeBaseFiles || !isEditable) {
    return (
      <Box>
        <Button
          variant="outlined"
          color="primary"
          component="label"
          onClick={() => onBrowseFiles()}
          disabled={!isEditable}
        >
          Browse Files
        </Button>
      </Box>
    );
  }

  return (
    <DropZone
      height="160px"
      onDrop={(files) => {
        try {
          const file = getAndValidateFirstFileFromFileList({
            files,
            validContentTypes: api.KnowledgeBaseFile.VALID_CONTENT_TYPES,
            maxFileSizeInBytes: api.KnowledgeBaseFile.MAX_KNOWLEDGE_BASE_FILE_SIZE_IN_BYTES,
          });
          setFile(file);
        } catch (error: unknown) {
          if (error instanceof Error) {
            showError(error.message);
          }
        }
      }}
    >
      <Stack alignItems="center" justifyContent="center" gap={2} height="100%" width="100%">
        <NoteAddOutlinedIcon />
        <Text variant="body2" bold>
          Drop file here to upload
        </Text>
        <Button
          variant="outlined"
          color="primary"
          component="label"
          onClick={() => onBrowseFiles()}
        >
          Browse Files
        </Button>
      </Stack>
    </DropZone>
  );
}
